import React, { Fragment, useState } from 'react'
import { styled, useTheme } from '@mui/system'
import {
    Paper,
    Grid,
    Slide,
    Switch,
    FormControlLabel,
    Input,
} from '@mui/material'
import {
    Card,
    CardMedia,
    Dialog,
    Box,
    Stack,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
    IconButton,
    Icon,
    InputAdornment,
    Button,
} from '@mui/material'
import { ShiftPicker } from 'app/components'
import { Paragraph } from 'app/components/Typography'

const CustomSwitch = styled((props) => (
    <Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
    />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor:
                    theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}))

const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="up" ref={ref} {...props} />
})

const ImportMeasurementMenu = ({ open, handleClose }) => {
    const [selectedFile, setSelectedFile] = useState();
    const [fileSelected, setFileSelected] = useState(false);
    const [userRole, setUserRole] = React.useState(4)
    const [shift, setShift] = React.useState(1)
    const [date, setDate] = React.useState(new Date())
    const [userLogin, setUserLogin] = React.useState('')
    const handleRoleChange = (event) => {
        setUserRole(event.target.value)
    }
    const handleLoginChange = (event) => {
        setUserLogin(event.target.value)
    }
    const handleMouseDownSearch = (event) => {
        event.preventDefault()
    }
    const handleClickSearch = (ev) => {
        console.log('Search Click')
    }
    const fileChangeHandler = (event)=>{
        setSelectedFile(event.target.files[0]);
        setFileSelected(true);
    }
    const handleUpload = (ev) => {
        handleClose(selectedFile, shift, date)
    }
    const handleShiftChange =  (date, shift) => {
        setShift(shift.shift_id)
        setDate(date)
    }

    const handleCancel = (ev) => {
        handleClose(null, null, null)
    }
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>การนำเข้าข้อมูล</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    <Stack direction="column" spacing={2}>
                        <FormControl
                            sx={{ m: 0, minWidth: 230, mt: 1 }}
                            size="small"
                        >
                            <Paragraph
                                sx={{
                                    fontWeight: 'bold',
                                    color: '#1F4173',
                                }}
                            >
                                ไฟล์
                            </Paragraph>
                            <Button variant="contained" component="label">
                            {fileSelected ? <span>{selectedFile.name}</span>:<span>นำเข้าข้อมูล</span>}
                                <input type="file"  onChange={fileChangeHandler}  hidden />
                            </Button>
                        </FormControl>

                        <FormControl
                            sx={{ m: 0, minWidth: 230, mt: 1 }}
                            size="small"
                        >
                            <Paragraph
                                sx={{
                                    fontWeight: 'bold',
                                    color: '#1F4173',
                                }}
                            >
                                รอบการตรวจ
                            </Paragraph>
                            <ShiftPicker
                                handleShiftChange={handleShiftChange}
                            />
                        </FormControl>
                    </Stack>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button onClick={handleUpload}>Add</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ImportMeasurementMenu
